// This file is generated by a script and should not be modified directly.
const markdown: string =
  "This element groups the different means of application offered to candidates.\n\n- URL to redirect the candidate to apply\n- Phone number of the person in charge of recruitment\n- Identifier of the job opportunity to use to allow your users to apply directly from your site using [this additional API](./candidature-offre).\n"
export default markdown
